const messages = {
	invalidEmail: 'Enter a valid email address.',
	passwordResetRequestFailed: 'Password reset could not be completed. Please try again.',
	captchaValidationFailed: 'Security verification failed. Please try again.',
	captchaUnavailable: 'Security verification is not ready. Please reload the page and try again.',
	networkError: 'Password reset could not reach the server. Check your connection and try again.',
};

function safeReference(value) {
	return typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(value) ? value : null;
}

function browserReference() {
	if(window.crypto && window.crypto.getRandomValues) {
		const bytes = new Uint8Array(16);
		window.crypto.getRandomValues(bytes);
		return `browser-${Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')}`;
	}
	// This is a support reference, never a credential. Older webviews still
	// need a visible reference when no server response or Web Crypto is available.
	return `browser-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export default function passwordResetError(error, clientCode) {
	const response = error && error.response;
	const data = response && response.data;
	const envelope = data && (data.errors || (data.data && data.data.errors) || data.error);
	const errors = Array.isArray(envelope) ? envelope : [envelope];
	const detail = errors.find(value => value && typeof value === 'object') || {};
	const headerReference = response && response.headers && Object.keys(response.headers)
		.filter(key => ['x-error-reference', 'x-correlation-id'].includes(key.toLowerCase()))
		.map(key => safeReference(response.headers[key])).find(Boolean);
	const reference = safeReference(detail.errorReference) || safeReference(detail.error_reference)
		|| safeReference(detail.correlationId) || headerReference;
	const hasKnownCode = Object.prototype.hasOwnProperty.call(messages, detail.code);
	const code = clientCode || (hasKnownCode ? detail.code : response ? 'passwordResetRequestFailed' : 'networkError');
	const status = response && Number(response.status);
	return {
		message: messages[code],
		code,
		status: status >= 100 && status <= 599 ? status : null,
		reference: reference || browserReference(),
		browserReference: !reference,
	};
}
